export default __webpack_public_path__ + "static/media/Background_00156.ae69ba9e.png";